import { Component } from '@angular/core';
import {
  ResourceHeroComponent,
  ResourceHeroSlide,
} from '../../shared/components/resource-hero/resource-hero.component';
import { CalloutsComponent } from './callouts/callouts.component';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { CtaBottomComponent } from '../../shared/components/cta-bottom/cta-bottom.component';
import { References } from './references/references';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: 'early-detection',
  imports: [
    ResourceHeroComponent,
    CalloutsComponent,
    JumpToComponent,
    CtaBottomComponent,
    References,
    ReviewBarComponent,
  ],
  templateUrl: './early-detection.component.html',
  styleUrl: './early-detection.component.scss',
})
export class EarlyDetectionComponent {
  heroSlides: ResourceHeroSlide[] = [
    {
      id: 'early-detection',
      backgroundImageName: 'early-detection-bg',
      backgroundUsesTabletVariant: false,
      sillhouetteImageName: 'hero-sillhouette-early-detection',
      sillhouetteUsesTabletVariant: false,
      sillhouette: {
        mobile: {
          width: 392,
          top: -43,
          right: -2,
        },
        tablet: {
          width: 436,
          top: -46,
          right: 77,
        },
        desktop: {
          width: 589,
          top: -64,
          right: 104,
        },
      },
      disclaimer: {
        mobile: {
          left: 30,
          bottom: 5,
        },
        tablet: {
          left: 48,
          bottom: 5,
        },
        desktop: {
          left: 18,
          bottom: 34,
        },
      },
      sillhouetteAlt: 'A healthcare provider smiling',
      title: `WHY EARLY DETECTION <br class="d-none d-lg-block" /><span class="text-primary"><em>MATTERS</em></span>`,
      text: `Type 1 diabetes (T1D) is often only diagnosed when patients are in diabetic ketoacidosis (DKA),<sup>1</sup> a serious medical emergency which may also potentially have a long-term impact on health.<sup>2</sup> If detected in advance, those consequences can be mitigated, and patients may have more time to prepare for what’s coming. `,
      isFirstSlide: true,
    },
  ];

  jumpToData = [
    {
      buttonLabel: 'Severe outcomes',
      buttonUrl: '/',
      buttonFragment: 'severe-outcomes',
    },
    {
      buttonLabel: 'Beta cell function',
      buttonUrl: '/',
      buttonFragment: 'beta-cell-function',
    },
    {
      buttonLabel: 'Metabolic memory',
      buttonUrl: '/',
      buttonFragment: 'metabolic-memory',
    },
    {
      buttonLabel: 'Stay connected',
      buttonUrl: '/',
      buttonFragment: 'stay-connected',
    },
  ];

  ctaBottomData = {
    icon: 'mail',
    alt: 'An envelope',
    title: `Looking for HCP-specific screening <br class='d-none d-lg-block'>resources? We’ve got you covered! `,
    button: {
      buttonLabel: 'Find Resources',
      buttonUrl: 'hcp/t1d-screening-resources/',
      openInNewTab: false,
      buttonIcon: 'right-icon',
    },
  };
}
